import { render } from "./searchbox.vue?vue&type=template&id=6728200d"
import script from "./searchbox.vue?vue&type=script&lang=js"
export * from "./searchbox.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__